const actionsRoute = {
};

export default actionsRoute;
